import LiveBoardScreenComponent from "./live-board-screen-component";
import ReactModal from "react-modal";
import { componentStyles } from "./live-board-modal.scss";
import classNames from "classnames";

const liveBoardPopupModal = (props) => {
  const {
    showLiveBoard,
    closeLiveBoard,
    translate,
    openLiveBoard,
    liveBoardOpenButtonCtaText,
    boardPartiallyVisible,
    openPeekToBoard,
    closePeekToBoard
  } = props;

  return (
    <ReactModal
      className={classNames("live-board-modal", {
        "board-partially-visible": boardPartiallyVisible,
        "fullscreen-board": showLiveBoard
      })}
      overlayClassName={classNames("live-board-modal-overlay", {
        "board-partially-visible": boardPartiallyVisible,
        "fullscreen-board": showLiveBoard
      })}
      bodyOpenClassName={classNames("modal-open", {
        "board-partially-visible": boardPartiallyVisible,
        "fullscreen-board": showLiveBoard
      })}
      isOpen={true}
    >
      <LiveBoardScreenComponent
        translate={translate}
        closeLiveBoard={closeLiveBoard}
        openLiveBoard={openLiveBoard}
        liveBoardOpenButtonCtaText={liveBoardOpenButtonCtaText}
        boardPartiallyVisible={boardPartiallyVisible}
        openPeekToBoard={openPeekToBoard}
        closePeekToBoard={closePeekToBoard}
        showLiveBoard={showLiveBoard}
      />
      <style jsx>{componentStyles}</style>
    </ReactModal>
  );
};

export default liveBoardPopupModal;
